import { Box, Typography } from "@drone-js/core";
import type { FunctionComponent } from "react";

const boldRegex = /<b>(.*?)<\/b>/g;
const boldTagRegex = /<b>|<\/b>/g;

export interface BoldTextParserProps {
    text: string;
}

export const BoldTextParser: FunctionComponent<BoldTextParserProps> = ({ text }) => {
    const boldTexts = text
        .match(boldRegex)
        ?.map((boldValue) => boldValue.replace(boldTagRegex, "").replace(/ /g, "\u00a0"));
    const allTexts = text.split(boldTagRegex).map((t) => t.replace(/ /g, "\u00a0"));

    return boldTexts?.length > 0 ? (
        <Box display="flex" flexWrap="wrap">
            {allTexts.map((splitText) => (
                <Typography
                    variant={boldTexts.includes(splitText) ? "body-default-strong" : "body-default"}
                    key={splitText}
                >
                    {splitText}
                </Typography>
            ))}
        </Box>
    ) : (
        <Typography variant="body-default">{text}</Typography>
    );
};
